import ConsumerPromotionActions from "../actions/consumerPromotionActions";

const ConsumerPromotionReducer = (state = {
  isConsumerPromotionLoading: false, consumerPromotionHasError: false,
  isGetConsumerPromotionByIdLoading: false, getConsumerPromotionByIdHasError: false,
  consumerPromotionTypesLoading: false, consumerPromotionTypesHasError: false,
  updateConsumerPromotionLoading: false, updateConsumerPromotionHasError: false,
  isConsumerPromotionListLoading: false, ConsumerPromotionListHasError: false,
  submitConsumerPromotionIsLoading: false, submitConsumerPromotionHasError: false,
  consumerPromotionHistoryIsLoading: false, consumerPromotionHistoryHasError: false,
  deactivateConsumerPromotionIsLoading: false, deactivateConsumerPromotionHasError: false,
  deleteConsumerPromotionIsLoading: false, deleteConsumerPromotionHasError: false,
  isConsumerPromotionListCountLoading: false, ConsumerPromotionListCountHasError: false
}, action) => {
  switch (action.type) {
    case ConsumerPromotionActions.CONSUMER_PROMOTION_REQUEST:
      return {
        ...state,
        isConsumerPromotionLoading: true,
        consumerPromotionHasError: false,
        consumerPromotion: null
      };
    case ConsumerPromotionActions.CONSUMER_PROMOTION_SUCCESSFUL:
      return {
        ...state,
        isConsumerPromotionLoading: false,
        consumerPromotion: action.data,
        consumerPromotionHasError: false
      };
    case ConsumerPromotionActions.CONSUMER_PROMOTION_FAILED:
      return {
        ...state,
        errorMessage: action.error,
        consumerPromotion: null,
        isConsumerPromotionLoading: false,
        consumerPromotionHasError: true
      };


    //********** GET COMSUMER PROMOTION FROM ID ***********
    case ConsumerPromotionActions.GET_CONSUMER_PROMOTION_BY_ID_REQUEST:
      return {
        ...state,
        isGetConsumerPromotionByIdLoading: true,
        getConsumerPromotionByIdHasError: false,
        consumerPromotionById: null
      };
    case ConsumerPromotionActions.GET_CONSUMER_PROMOTION_BY_ID_SUCCESSFUL:
      return {
        ...state,
        isGetConsumerPromotionByIdLoading: false,
        consumerPromotionById: action.data,
        getConsumerPromotionByIdHasError: false
      };
    case ConsumerPromotionActions.GET_CONSUMER_PROMOTION_BY_ID_FAILED:
      return {
        ...state,
        errorMessage: action.error,
        consumerPromotionById: null,
        isGetConsumerPromotionByIdLoading: false,
        getConsumerPromotionByIdHasError: true
      };


    //********** COMSUMER PROMOTION TYPES ***********
    case ConsumerPromotionActions.CONSUMER_PROMOTION_TYPES_REQUEST:
      return {
        ...state,
        consumerPromotionTypesLoading: true,
        consumerPromotionTypesHasError: false,
        consumerPromotionTypes: null
      };
    case ConsumerPromotionActions.CONSUMER_PROMOTION_TYPES_SUCCESSFUL:
      return {
        ...state,
        consumerPromotionTypesLoading: false,
        consumerPromotionTypes: action.data,
        consumerPromotionTypesHasError: false
      };
    case ConsumerPromotionActions.CONSUMER_PROMOTION_TYPES_FAILED:
      return {
        ...state,
        errorMessage: action.error,
        consumerPromotionTypes: null,
        consumerPromotionTypesLoading: false,
        consumerPromotionTypesHasError: true
      };


    //********** UPDATE COMSUMER PROMOTION ***********
    case ConsumerPromotionActions.UPDATE_CONSUMER_PROMOTION_REQUEST:
      return {
        ...state,
        updateConsumerPromotionLoading: true,
        updateConsumerPromotionHasError: false,
        updateConsumerPromotion: null
      };
    case ConsumerPromotionActions.UPDATE_CONSUMER_PROMOTION_SUCCESSFUL:
      return {
        ...state,
        updateConsumerPromotionLoading: false,
        updateConsumerPromotion: action.data,
        updateConsumerPromotionHasError: false
      };
    case ConsumerPromotionActions.UPDATE_CONSUMER_PROMOTION_FAILED:
      return {
        ...state,
        errorMessage: action.error,
        updateConsumerPromotion: null,
        updateConsumerPromotionLoading: false,
        updateConsumerPromotionHasError: true
      };


    //********** GET COMSUMER PROMOTION LIST ***********
    case ConsumerPromotionActions.GET_CONSUMER_PROMOTION_LIST_REQUEST:
      return {
        ...state,
        isConsumerPromotionListLoading: true,
        ConsumerPromotionListHasError: false,
        consumerPromotionList: null
      };
    case ConsumerPromotionActions.GET_CONSUMER_PROMOTION_LIST_SUCCESSFUL:
      return {
        ...state,
        isConsumerPromotionListLoading: false,
        consumerPromotionList: action.data,
        ConsumerPromotionListHasError: false
      };
    case ConsumerPromotionActions.GET_CONSUMER_PROMOTION_LIST_FAILED:
      return {
        ...state,
        errorMessage: action.error,
        consumerPromotionList: null,
        isConsumerPromotionListLoading: false,
        ConsumerPromotionListHasError: true
      };


    //********** SUBMIT COMSUMER PROMOTION ***********
    case ConsumerPromotionActions.SUBMIT_CONSUMER_PROMOTION_REQUEST:
      return {
        ...state,
        submitConsumerPromotionIsLoading: true,
        submitConsumerPromotionHasError: false,
        submitConsumerPromotion: null
      };
    case ConsumerPromotionActions.SUBMIT_CONSUMER_PROMOTION_SUCCESSFUL:
      return {
        ...state,
        submitConsumerPromotionIsLoading: false,
        submitConsumerPromotion: action.data,
        submitConsumerPromotionHasError: false
      };
    case ConsumerPromotionActions.SUBMIT_CONSUMER_PROMOTION_FAILED:
      return {
        ...state,
        errorMessage: action.error,
        submitConsumerPromotion: null,
        submitConsumerPromotionIsLoading: false,
        submitConsumerPromotionHasError: true
      };


    //********** COMSUMER PROMOTION HISTORY ***********
    case ConsumerPromotionActions.CONSUMER_PROMOTION_HISTORY_REQUEST:
      return {
        ...state,
        consumerPromotionHistoryIsLoading: true,
        consumerPromotionHistoryHasError: false,
        consumerPromotionHistory: null
      };
    case ConsumerPromotionActions.CONSUMER_PROMOTION_HISTORY_SUCCESSFUL:
      return {
        ...state,
        consumerPromotionHistoryIsLoading: false,
        consumerPromotionHistory: action.data,
        consumerPromotionHistoryHasError: false
      };
    case ConsumerPromotionActions.CONSUMER_PROMOTION_HISTORY_FAILED:
      return {
        ...state,
        errorMessage: action.error,
        consumerPromotionHistory: null,
        consumerPromotionHistoryIsLoading: false,
        consumerPromotionHistoryHasError: true
      };


    //********** DEACTIVATE COMSUMER PROMOTION ***********
    case ConsumerPromotionActions.DEACTIVATE_CONSUMER_PROMOTION_REQUEST:
      return {
        ...state,
        deactivateConsumerPromotionIsLoading: true,
        deactivateConsumerPromotionHasError: false,
        deactivateConsumerPromotion: null
      };
    case ConsumerPromotionActions.DEACTIVATE_CONSUMER_PROMOTION_SUCCESSFUL:
      return {
        ...state,
        deactivateConsumerPromotionIsLoading: false,
        deactivateConsumerPromotion: action.data,
        deactivateConsumerPromotionHasError: false
      };
    case ConsumerPromotionActions.DEACTIVATE_CONSUMER_PROMOTION_FAILED:
      return {
        ...state,
        errorMessage: action.error,
        deactivateConsumerPromotion: null,
        deactivateConsumerPromotionIsLoading: false,
        deactivateConsumerPromotionHasError: true
      };


    //********** DELETE COMSUMER PROMOTION ***********
    case ConsumerPromotionActions.DELETE_CONSUMER_PROMOTION_REQUEST:
      return {
        ...state,
        deleteConsumerPromotionIsLoading: true,
        deleteConsumerPromotionHasError: false,
        deleteConsumerPromotion: null
      };
    case ConsumerPromotionActions.DELETE_CONSUMER_PROMOTION_SUCCESS:
      return {
        ...state,
        deleteConsumerPromotionIsLoading: false,
        deleteConsumerPromotion: action.data,
        deleteConsumerPromotionHasError: false
      };
    case ConsumerPromotionActions.DELETE_CONSUMER_PROMOTION_FAILED:
      return {
        ...state,
        errorMessage: action.error,
        deleteConsumerPromotion: null,
        deleteConsumerPromotionIsLoading: false,
        deleteConsumerPromotionHasError: true
      };


    //********** GET COMSUMER PROMOTION LIST COUNT ***********
    case ConsumerPromotionActions.GET_CONSUMER_PROMOTION_LIST_COUNT_REQUEST:
      return {
        ...state,
        isConsumerPromotionListCountLoading: true,
        ConsumerPromotionListCountHasError: false,
        consumerPromotionListCount: null
      };
    case ConsumerPromotionActions.GET_CONSUMER_PROMOTION_LIST_COUNT_SUCCESSFUL:
      return {
        ...state,
        isConsumerPromotionListCountLoading: false,
        consumerPromotionListCount: action.data,
        ConsumerPromotionListCountHasError: false
      };
    case ConsumerPromotionActions.GET_CONSUMER_PROMOTION_LIST_COUNT_FAILED:
      return {
        ...state,
        errorMessage: action.error,
        consumerPromotionListCount: null,
        isConsumerPromotionListCountLoading: false,
        ConsumerPromotionListCountHasError: true
      };
    default:
      return {
        ...state
      };
    //   break;
  }
};

export default ConsumerPromotionReducer;
